import { styled } from 'styled-components'

export const Container = styled.header`
  grid-area: header;
  position: sticky;
  top: 0;
  z-index: 18;
`
